import { Button } from '@/view/components/ui/button';
import { Printer } from 'lucide-react';
import { usePDF } from 'react-to-pdf';
import parse from 'html-react-parser';
import { useState } from 'react';
import { useRemoteClientGet } from '@/configs/http-client';
import { CatchMessageError } from '@/remote/catch-message-error';

interface ButtonPdfContractProps {
  idAluno: number,
  idPlano: number,
}


export function ButtonPdfContract({ idAluno, idPlano }: ButtonPdfContractProps) {
  const { remoteClientGet } = useRemoteClientGet()
  const { toPDF, targetRef } = usePDF({ filename: 'contrato.pdf' });
  const [isPrinting, setIsPrinting] = useState(false);
  const [data, setData] = useState('');

  console.log('idAluno', idAluno)
  console.log('idPlano', idPlano)
  const handlePrint = async () => {
    if (idAluno && idPlano) {
      try {
        const response = await remoteClientGet(`/vendas/contratos/aluno/${idAluno}/plano/${idPlano}`);
        console.log('Debug');
        console.log(response.data.data.conteudo);

        setData(response.data.data.conteudo + '');

        setIsPrinting(true);
        setTimeout(async () => {
          await toPDF();
          setIsPrinting(false);
        }, 100);
      } catch (error) {
        CatchMessageError(error);
      }
    }
  };

  return (
    <div>
      <div
        ref={targetRef}
        className={`
          fixed left-1/2 top-[2000%] transform -translate-x-1/2 -translate-y-1/2
          bg-white shadow-lg rounded-lg p-4 m-4 z-[9999]
          ${isPrinting ? 'block' : 'hidden'}
        `}
      >
        {parse(data)}
      </div>

      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8"
        onClick={handlePrint}
      >
        <Printer className="h-4 w-4" />
      </Button>
    </div>
  );

}